import type { UserReadPort, AuthSessionReadPort, MemberProfile } from '../core/types';

export interface UserReadService {
  getFacilityMemberProfiles(facilityId: string): Promise<MemberProfile[]>;
  getUserBusinessAdminCount(userId: string): Promise<number>;
  inviteMemberByEmail(params: {
    facilityId: string;
    email: string;
    fullName?: string;
    phone?: string;
  }): Promise<{
    userId: string;
    fullName: string | null;
    email: string;
    phone: string | null;
    existing: boolean;
  }>;
}

export interface AuthSessionReadService {
  getProfile(userId: string): Promise<unknown>;
  getUserRoles(userId: string): Promise<Array<{ id: string; role: string; business_id: string | null; facility_id: string | null }>>;
}

export function createUserReadService(port: UserReadPort): UserReadService {
  return {
    getFacilityMemberProfiles: (facilityId) => port.getFacilityMemberProfiles(facilityId),
    getUserBusinessAdminCount: (userId) => port.getUserBusinessAdminCount(userId),
    inviteMemberByEmail: (params) => port.inviteMemberByEmail(params),
  };
}

export function createAuthSessionReadService(port: AuthSessionReadPort): AuthSessionReadService {
  return {
    getProfile: (userId) => port.getProfile(userId),
    getUserRoles: (userId) => port.getUserRoles(userId),
  };
}
